import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import {
  authApi,
  brandApi,
  clientApi,
  commercialOffersApi,
  communicationHubApi,
  countryApi,
  filesApi,
  globalApi,
  itemApi,
  leadsApi,
  purchaseOrderApi,
  purchaseRequestApi,
  rolePermissionApi,
  supplierApi,
  supplierOfferApi,
  taskApi,
  usersApi,
  warehouseApi,
  warehousePackagesApi,
} from 'api';
import { dealsApi } from 'api/deals';
import contactFieldManagerReducer from 'components/common/ContactFieldManager/contactFieldManagerSlice';
import brandReducer from 'pages/admin/brands/brand/brandSlice';
import xsrfReducer from 'pages/auth/authSlice';
import { notificationApi } from 'api/notification';
import { ordersApi } from 'api/orders';

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [itemApi.reducerPath]: itemApi.reducer,
    [taskApi.reducerPath]: taskApi.reducer,
    [filesApi.reducerPath]: filesApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [leadsApi.reducerPath]: leadsApi.reducer,
    [dealsApi.reducerPath]: dealsApi.reducer,
    [brandApi.reducerPath]: brandApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [globalApi.reducerPath]: globalApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,
    [supplierApi.reducerPath]: supplierApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [rolePermissionApi.reducerPath]: rolePermissionApi.reducer,
    [purchaseRequestApi.reducerPath]: purchaseRequestApi.reducer,
    [communicationHubApi.reducerPath]: communicationHubApi.reducer,
    [commercialOffersApi.reducerPath]: commercialOffersApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [purchaseOrderApi.reducerPath]: purchaseOrderApi.reducer,
    [supplierOfferApi.reducerPath]: supplierOfferApi.reducer,
    [warehouseApi.reducerPath]: warehouseApi.reducer,
    [warehousePackagesApi.reducerPath]: warehousePackagesApi.reducer,
    contactFieldManager: contactFieldManagerReducer,
    xsrf: xsrfReducer,
    brand: brandReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      taskApi.middleware,
      itemApi.middleware,
      filesApi.middleware,
      brandApi.middleware,
      usersApi.middleware,
      leadsApi.middleware,
      dealsApi.middleware,
      globalApi.middleware,
      clientApi.middleware,
      countryApi.middleware,
      supplierApi.middleware,
      notificationApi.middleware,
      rolePermissionApi.middleware,
      purchaseRequestApi.middleware,
      communicationHubApi.middleware,
      commercialOffersApi.middleware,
      ordersApi.middleware,
      supplierOfferApi.middleware,
      purchaseOrderApi.middleware,
      warehouseApi.middleware,
      warehousePackagesApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
